import { idbStorage } from "investira.react.lib";

const storage = idbStorage({
  name: "investira_biz_001",
  storeName: "store_values",
});

export default storage;
